import {Dish} from '../../models';
import {makeActionCreator} from '../../redux-toolbelt';

export const setDirtyShoppingCart = makeActionCreator<'setDirtyShoppingCart', boolean>('setDirtyShoppingCart');
export const setMissingDishesIds = makeActionCreator<'setMissingDishesIds', Dish['dishId'][]>('setMissingDishesIds');
